import { tryCatch } from '@wix/funnel-utils';
import React, { useCallback, useRef, useState } from 'react';
import { TransitionType } from '../../domain';
import { back as doBack } from './actions';
import { addHistoryEntry } from './addHistoryEntry';
import { addTemplateData } from './addTemplateData';
import { WixFlowContext } from './WixFlowContext';
export const WixFlowProvider = props => {
  const {
    children,
    flowContext,
    updateFlowContext,
    service,
    fallback: Fallback
  } = props;
  const questionKeysOnPagesRef = useRef({});
  const [externalTransition, setExternalTransition] = useState();
  const [isFallbackShown, setIsFallbackShown] = useState(false);
  const showFallback = useCallback(() => setIsFallbackShown(true), [setIsFallbackShown]);
  const next = useCallback(function (answers, metadata) {
    if (answers === void 0) {
      answers = {};
    }
    const getNextTransition = async flowContext => {
      const [error, nextTransition] = await tryCatch(() => service.getNextTransition(flowContext));
      if (error) {
        showFallback();
        return;
      }
      if (nextTransition.type === TransitionType.EXTERNAL) {
        setExternalTransition(nextTransition.targetUrl);
        return;
      }
      updateFlowContext(addHistoryEntry(flowContext, nextTransition));
      const historyEntries = flowContext.historyEntries;
      const currentPageId = historyEntries[historyEntries.length - 1].pageId;
      questionKeysOnPagesRef.current = {
        ...questionKeysOnPagesRef.current,
        [currentPageId]: Object.keys(answers)
      };
    };
    void getNextTransition(addTemplateData(flowContext, answers, metadata));
  }, [flowContext, service, showFallback, updateFlowContext]);
  const back = useCallback(() => {
    doBack({
      flowContext,
      updateFlowContext,
      questionKeysOnPagesRef
    });
  }, [flowContext, questionKeysOnPagesRef, updateFlowContext]);
  const value = {
    flowContext,
    next,
    back,
    externalTransition,
    service,
    showFallback
  };
  if (isFallbackShown && Fallback) {
    return /*#__PURE__*/React.createElement(Fallback, null);
  }
  return /*#__PURE__*/React.createElement(WixFlowContext.Provider, {
    value: value
  }, children);
};
//# sourceMappingURL=WixFlowProvider.js.map